<template>
  <span>
    <v-btn-toggle v-model="toggle" dense light rounded>
      <v-btn
        :disabled="processingStop"
        x-small
        fab
        color="error"
        v-if="timeclockIsRunning && hasAccess('timeClock.stop')"
        @click="stopTimer(parentItem.id)"
      >
        <v-icon>stop</v-icon>
      </v-btn>
    </v-btn-toggle>
    <ConfirmStop 
    :show="showConfirmStop" 
    @onClosed="showConfirmStop = false" 
    :task="parentItem"
    :timeClockEntry="item"
    @onSubmitted="submitRequest"
    />
  </span>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import formatterMixin from "@/mixins/formatterMixin";
import ConfirmStop from "./___StopPopup";
import _ from "lodash";

export default {
  components: {
    ConfirmStop
  },

  mixins: [formatterMixin],
  props: {
    item: Object,
    parentItem: Object
  },

  data() {
    return {
      toggle: "",
      processingStop: false,
      trackable: ["open", "inprogress"],
      notTrackable: ["canceled", "completed", "invoiced"],
      showConfirmStop: false
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account.data.user,
      timeclockFilter: (state) => state.timeclock.tableFilter,
      taskDataRunning: (state) => state.task.dataRunning,
    }),

    ...mapGetters('account', ['hasAccess']),

    isAlreadyRunning() {
      return (
        this.taskDataRunning.filter((item) => {
          return !!item.runningStartTime;
        }).length > 0
      );
    },

    timeclockIsRunning() {
      const isRunning = _.has(this.item, "startTime") &&
        _.has(this.item, "stopTime") &&
        !!this.item.startTime &&
        !this.item.stopTime;
      return isRunning;
    },
  },

  watch: {
    showConfirmStop(n) {
      if(!n) {
        setTimeout(() => {
          this.processingStop = false;
        }, 750);
      }
    },

    task(n, o) {
      if (n && JSON.stringify(n) !== JSON.stringify(o)) {
        this.form = {
          ..._.pick(n, _.keys(this.defaultInputs)),
        };
      }
    },
  },

  methods: {
    ...mapActions("timeclock", [
      "getAll",
      "entryCreate",
      "entryUpdate",
      "update",
    ]),
    ...mapActions("task", ["updateStatus"]),
    ...mapActions({
      getTaskById: "task/getById",
    }),

    getCurrentPosition() {
      let support = `geolocation` in navigator;
      if (!support) {
        alert(
          "This browser doesnt support geolocation, please upgrade your browser to latest version!"
        );
        return false;
      }
      let geoSettings = {
        enableHighAccuracy: true,
        maximumAge: 20000,
        timeout: 10000,
      };

      return new Promise(function (resolve, reject) {
        return navigator.geolocation.getCurrentPosition(
          resolve,
          reject,
          geoSettings
        );
      });
    },

    async submitRequest(questionnaireTimeclockEntry) {
      const pos = await this.getCurrentPosition()
        .then((pos) => {
          return pos;
        })
        .catch(() => {
          // alert("Getting location fail because " + e.message);
        });

      let data = {
        ...questionnaireTimeclockEntry,
        stopTime: this.momentLocal(),
        stopLatitude: this.optional(pos, "coords.latitude", 0),
        stopLongitude: this.optional(pos, "coords.latitude", 0),
      };
      delete data.jobMaterialsUsed;
      delete data.questionnaire;
      await this.entryUpdate(data);
      await this.getAll({
        ...this.timeclockFilter,
        noLoading: true
      });
      await this.$emit("onUpdate");
    },

    async stopTimer(taskId) {
      this.processingStop = true;
      await this.getTaskById(taskId);
      this.showConfirmStop = true;
    },
  },
};
</script>